import React from 'react';
import GoogleCalendarWidget from '../../GoogleCalendarWidget';

const OverviewTab = ({
  activeTab,
  analytics,
  loading,
  notifications,
  removeNotification,
  setActiveTab
}) => {
  return (
    <>
{activeTab === 'overview' && (
              <div className="space-y-8">
                {/* Loading State */}
                {loading && (
                  <div className="flex justify-center items-center py-12">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    <span className="ml-3 text-gray-600">Dashboard wird geladen...</span>
                  </div>
                )}

                {!loading && (
                  <>
                    {/* Notification System for Dashboard */}
                    {notifications.length > 0 && (
                      <div className="fixed top-4 right-4 z-50 space-y-2">
                        {notifications.map((notification) => (
                          <div
                            key={notification.id}
                            className={`max-w-sm p-4 rounded-lg shadow-lg border transform transition-all duration-300 ${
                              notification.type === 'success'
                                ? 'bg-green-50 border-green-200 text-green-800'
                                : notification.type === 'error'
                                ? 'bg-red-50 border-red-200 text-red-800'
                                : 'bg-blue-50 border-blue-200 text-blue-800'
                            }`}
                          >
                            <div className="flex items-center justify-between">
                              <div className="flex items-center space-x-2">
                                <span className="text-lg">
                                  {notification.type === 'success' ? '✅' :
                                   notification.type === 'error' ? '❌' : 'ℹ️'}
                                </span>
                                <p className="text-sm font-medium">{notification.message}</p>
                              </div>
                              <button
                                onClick={() => removeNotification(notification.id)}
                                className="text-gray-400 hover:text-gray-600"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                {/* Lagebericht – 4 echte Kennzahlkarten */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {[
                    {
                      label: 'Lernende gesamt',
                      value: analytics?.summary?.total_learners ?? analytics?.total_users ?? 0,
                      sub: `${analytics?.summary?.total_categories ?? analytics?.total_categories ?? 0} Kategorie(n) aktiv`,
                      icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z',
                      color: 'text-blue-600', bg: 'bg-blue-50', border: 'border-l-blue-500',
                    },
                    {
                      label: 'Ø Abschlussrate',
                      value: `${analytics?.summary?.avg_completion_pct ?? 0}%`,
                      sub: `${analytics?.summary?.total_modules ?? analytics?.total_modules ?? 0} aktive Module`,
                      icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
                      color: 'text-teal-600', bg: 'bg-teal-50', border: 'border-l-teal-500',
                    },
                    {
                      label: 'Abschlussgespräch bestanden',
                      value: analytics?.exam_stats?.passed ?? 0,
                      sub: `${analytics?.exam_stats?.failed ?? 0} nicht bestanden`,
                      icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
                      color: 'text-green-600', bg: 'bg-green-50', border: 'border-l-green-500',
                    },
                    {
                      label: 'Nachholbedarf',
                      value: analytics?.summary?.at_risk_count ?? 0,
                      sub: (analytics?.summary?.at_risk_count ?? 0) > 0
                        ? '≥ 7 Tage inaktiv'
                        : (analytics?.summary?.total_learners ?? 0) === 0
                          ? 'Keine Lernenden'
                          : 'Kein Rückstand ≥ 7 Tage',
                      icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
                      color: (analytics?.summary?.at_risk_count ?? 0) > 0 ? 'text-red-600' : 'text-gray-400',
                      bg: (analytics?.summary?.at_risk_count ?? 0) > 0 ? 'bg-red-50' : 'bg-gray-50',
                      border: (analytics?.summary?.at_risk_count ?? 0) > 0 ? 'border-l-red-500' : 'border-l-gray-300',
                    },
                  ].map((card, i) => (
                    <div key={i} className={`stat-card bg-white rounded-xl shadow-sm p-5 border-l-4 ${card.border} border border-slate-100`}>
                      <div className="flex items-start justify-between">
                        <div>
                          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">{card.label}</p>
                          <p className={`text-3xl font-bold ${card.color}`}>{card.value}</p>
                          <p className="text-xs text-gray-400 mt-1">{card.sub}</p>
                        </div>
                        <div className={`p-2 ${card.bg} rounded-lg`}>
                          <svg className={`w-5 h-5 ${card.color}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={card.icon} />
                          </svg>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* ── LAGEBERICHT ── */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

                  {/* Lernpfad-Status */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                    <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">Lernpfad – aktueller Stand</h3>
                    {(() => {
                      const stats = analytics?.user_stats || [];
                      const notStarted  = stats.filter(u => u.completed_modules === 0).length;
                      const inProgress  = stats.filter(u => u.completed_modules > 0 && u.completion_pct < 100).length;
                      const done        = stats.filter(u => u.completion_pct >= 100).length;
                      const total       = stats.length || 1;
                      return (
                        <div className="space-y-3">
                          {[
                            { label: 'Noch nicht gestartet', count: notStarted, color: 'bg-gray-300', text: 'text-gray-600' },
                            { label: 'In Bearbeitung',       count: inProgress, color: 'bg-blue-400',  text: 'text-blue-700' },
                            { label: 'Abgeschlossen',        count: done,       color: 'bg-green-500', text: 'text-green-700' },
                          ].map(row => (
                            <div key={row.label}>
                              <div className="flex justify-between text-sm mb-1">
                                <span className={`font-medium ${row.text}`}>{row.label}</span>
                                <span className="text-gray-500">{row.count} Lernende</span>
                              </div>
                              <div className="h-2.5 bg-gray-100 rounded-full overflow-hidden">
                                <div className={`h-full ${row.color} rounded-full transition-all`} style={{ width: `${(row.count / total) * 100}%` }} />
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                  </div>

                  {/* Abschlussgespräch-Status */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                    <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">Abschlussgespräch – aktueller Stand</h3>
                    <div className="space-y-2">
                      {[
                        { label: 'Bestanden',      count: analytics?.exam_stats?.passed      ?? 0, dot: 'bg-green-500' },
                        { label: 'Termin gebucht', count: analytics?.exam_stats?.booked       ?? 0, dot: 'bg-blue-500'  },
                        { label: 'Bereit',         count: analytics?.exam_stats?.ready        ?? 0, dot: 'bg-indigo-400' },
                        { label: 'Nicht bestanden',count: analytics?.exam_stats?.failed       ?? 0, dot: 'bg-red-500'  },
                        { label: 'Noch nicht bereit', count: analytics?.exam_stats?.not_started ?? 0, dot: 'bg-gray-300' },
                      ].map(row => (
                        <div key={row.label} className="flex items-center justify-between py-1.5 border-b border-gray-50 last:border-0">
                          <div className="flex items-center gap-2">
                            <span className={`w-2.5 h-2.5 rounded-full ${row.dot} shrink-0`} />
                            <span className="text-sm text-gray-700">{row.label}</span>
                          </div>
                          <span className="text-sm font-semibold text-gray-900">{row.count}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Nachholbedarf & Neue Accounts */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

                  {/* Nachholbedarf – Top 5 */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">Nachholbedarf</h3>
                      <button onClick={() => setActiveTab('analytics')} className="text-xs text-teal-600 hover:underline font-medium">Alle ansehen</button>
                    </div>
                    {(() => {
                      const atRisk = (analytics?.user_stats || []).filter(u => u.at_risk).slice(0, 5);
                      const neverActive = (analytics?.user_stats || []).filter(u => !u.last_active).slice(0, 5);
                      const show = atRisk.length > 0 ? atRisk : neverActive;
                      if (show.length === 0) return (
                        <div className="flex items-center gap-2 text-green-600 text-sm py-4">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          Alle Lernenden sind auf Kurs
                        </div>
                      );
                      const label = atRisk.length > 0 ? 'Tage inaktiv' : 'Noch nie eingeloggt';
                      return (
                        <div className="space-y-2">
                          {atRisk.length === 0 && neverActive.length > 0 && (
                            <p className="text-xs text-gray-400 mb-2">Accounts ohne bisherige Aktivität:</p>
                          )}
                          {show.map(u => (
                            <div key={u.user_id} className="flex items-center justify-between py-1.5">
                              <div className="min-w-0">
                                <p className="text-sm font-medium text-gray-900 truncate">{u.name}</p>
                                <p className="text-xs text-gray-400">{u.completion_pct}% abgeschlossen</p>
                              </div>
                              <span className="text-xs font-semibold text-red-600 shrink-0 ml-3">
                                {u.days_inactive != null ? `${u.days_inactive}d ${label}` : label}
                              </span>
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                  </div>

                  {/* Neue Accounts ohne Aktivität */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">Noch nicht gestartet</h3>
                      <button onClick={() => setActiveTab('users')} className="text-xs text-teal-600 hover:underline font-medium">Nutzer verwalten</button>
                    </div>
                    {(() => {
                      const newUsers = (analytics?.user_stats || []).filter(u => u.completed_modules === 0).slice(0, 6);
                      if (newUsers.length === 0) return (
                        <div className="flex items-center gap-2 text-green-600 text-sm py-4">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          Alle haben bereits begonnen
                        </div>
                      );
                      return (
                        <div className="space-y-2">
                          {newUsers.map(u => (
                            <div key={u.user_id} className="flex items-center justify-between py-1.5 border-b border-gray-50 last:border-0">
                              <div className="min-w-0">
                                <p className="text-sm font-medium text-gray-900 truncate">{u.name}</p>
                                <p className="text-xs text-gray-400 capitalize">{u.role}</p>
                              </div>
                              <span className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full shrink-0 ml-3">0% gestartet</span>
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                  </div>
                </div>

                {/* Google Calendar Status */}
                <GoogleCalendarWidget />
                  </>
                )}
              </div>
            )}
    </>
  );
};

export default OverviewTab;
